import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  vehicles: [],
  allVehicles: [],
  totalPages: 0,
  totalRecords: 0,
  vehicle: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_108: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Vehicles(state, vehicles) {
    state.vehicles = vehicles.items;
    state.totalPages = vehicles.totalPages;
    state.totalRecords = vehicles?.totalRecords ?? 0;
  },
  SET_AllVehicles(state, vehicles) {
    state.allVehicles = vehicles;
  },
  SET_Vehicle(state, vehicle) {
    state.vehicle = vehicle;
  },
};
const actions = {
  errorVehicle({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllVehicles({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Vehicles/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllVehicles', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
  getVehiclesWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, code, imei, cityId, zoneId, stationId, vehicleTypeId, isBroken },
  ) {
    var url = '/Vehicles/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (code) {
      url += '&Code=' + code;
    }
    if (imei) {
      url += '&Imei=' + imei;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    if (zoneId) {
      url += '&ZoneId=' + zoneId;
    }
    if (stationId) {
      url += '&StationId=' + stationId;
    }
    if (vehicleTypeId) {
      url += '&VehicleTypeId=' + vehicleTypeId;
    }
    if (isBroken != null && isBroken != undefined) {
      url += '&IsBroken=' + isBroken;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Vehicles', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
  addVehicle({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Vehicles', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
  getVehicle({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Vehicles/ById?vehicleId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Vehicle', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
  editVehicle({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Vehicles/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
  deleteVehicle({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Vehicles/Remove?vehicleId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorVehicle', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
